import React, { useEffect, useState } from 'react';

const OrderStatuselect = (props) => {

    const [orderStatus, setOrderStatus] = useState((props.orderStatus != null) ? props.orderStatus : "ממתין");
    const [colorforStat, setColorforStat] = useState("");

    useEffect(() => {
        setOrderStatus(props.orderStatus)
        setColorforStat(getOrdColorByStat(props.orderStatus))

    }, [props.orderStatus])

    const handleChange = (e) => {
        // if (orderStatus != "סגור") {
            setOrderStatus(e.target.value)
            setColorforStat(getOrdColorByStat(e.target.value))
            props.setOrderStatus(e.target.value)
        // }
    }

    const getOrdColorByStat = (status) => {

        switch (status) {
            case "ממתין לאישור":
                {
                    return "badge badge-primary";
                }
            case "בהכנה":
                {
                    return "badge badge-primary";
                }
            case "מוכן":
                {
                    return "badge badge-finished";
                }
            case "ממתין למשלוח":
                {
                    return "badge badge-danger";
                }
            case "ממתין לאיסוף":
                {
                    return "badge badge-warning";
                }
            case "נשלח":
                {
                    return "badge badge-secondary";
                }
            case "סגור":
                {

                    return "badge badge-dark";
                }
            case "מושהה":
                {

                    return "badge badge-Delayed";
                }
            case "מבוטל":
                {

                    return "badge badge-dark";
                }


            default:
                {
                    return "badge badge-primary";
                }


        }
    }
    return (
        <div className={`${colorforStat} fullWidth`}>
            <select
                className={`pointing onLeft selectInBlock ${(orderStatus == "לא פעיל") ?
                    "noActive" : (orderStatus == "לא מפורסם") ? "noPublish" : ""}`}
                value={orderStatus}
                onChange={handleChange}>
                <option value={"ממתין לאישור"}>ממתין לאישור</option>
                <option value={"בהכנה"}>בהכנה</option>
                <option value={"מוכן"}>מוכן</option>
                <option value={"ממתין לאיסוף"} >ממתין לאיסוף</option>
                <option value={"ממתין למשלוח"} >ממתין למשלוח</option>
                <option value={"נשלח"} >נשלח</option>
                <option value={"סגור"} >סגור</option>
                <option value={"מושהה"} >מושהה</option>
                <option value={"מבוטל"} >מבוטל</option>
            </select>
        </div>
    );
}

export default OrderStatuselect;